import * as actions from "../actionTypes"

const initialState = {
    value: false,
}

export default function myAccountMenu(state = initialState, action) {
    switch (action.type) {
        case actions.SET_MY_ACCOUNT_MENU_OPEN: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
